import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

/** @deprecated Kept only so existing PRICING_DETAILS_DYNAMIC_MARKUP fact rows still parse. */
export enum DynamicMarkupOption {
  YES = 'YES',
  NO = 'NO',
}

export enum MarkupTypeOption {
  FLAT = 'FLAT',
  VOLUME_BASED = 'VOLUME_BASED',
  SOURCED_WORKER = 'SOURCED_WORKER',
}

export const PRICING_DETAILS_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.PRICING_DETAILS_MARKUP_PERCENTAGE]: {
    schemaVersion: CompanyFactSchemaVersion.NUMBER_V1,
    displayName: 'Markup Percentage',
  },
  [CompanyFactKey.PRICING_DETAILS_MARKUP_TYPE]: {
    schemaVersion: CompanyFactSchemaVersion.SINGLE_SELECT_WITH_NOTES_V1,
    displayName: 'Markup Type',
    options: Object.values(MarkupTypeOption),
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
    purposeTooltip:
      'How markup is structured for this company — one entry per markup arrangement. Use notes to capture the specifics (flat percentage, volume-based range, sourced-worker rate).',
  },
  [CompanyFactKey.PRICING_DETAILS_CONVERSION_FEE]: {
    schemaVersion: CompanyFactSchemaVersion.CONVERSION_FEE_V1,
    displayName: 'Conversion Fee',
  },
  [CompanyFactKey.PRICING_DETAILS_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}
